"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseENSName = void 0;
const ethers_1 = require("ethers");
const common_1 = require("../../common");
function parseENSName(name) {
    let result = null;
    const parts = name
        .split('.')
        .map((name) => ethers_1.utils.nameprep(name))
        .filter((name) => !!name);
    if (parts.length > 1) {
        const name = parts.join('.');
        const rootName = parts.slice(1).join('.');
        result = {
            name,
            label: parts[0],
            labelHash: common_1.keccak256(parts[0]),
            hash: ethers_1.utils.namehash(name),
            root: {
                name: rootName,
                hash: ethers_1.utils.namehash(rootName),
            },
        };
    }
    return result;
}
exports.parseENSName = parseENSName;
